<template>
  <header>
    <!-- Show mobile header on small screens (up to md breakpoint) -->
    <div class="md:hidden">
      <AppHeaderMobile />
    </div>
    
    <!-- Show desktop header on medium and large screens -->
    <div class="hidden md:block xl:hidden">
      <AppHeaderDesktop />
    </div>
    
    <!-- Show special header for extra large screens -->
    <div class="hidden xl:block">
      <AppHeaderExtraLarge />
    </div>
  </header>
</template>

<script>
import AppHeaderDesktop from './AppHeaderDesktop.vue';
import AppHeaderMobile from './AppHeaderMobile.vue';
import AppHeaderExtraLarge from './AppHeaderExtraLarge.vue';

export default {
  name: 'AppHeader',
  components: {
    AppHeaderDesktop,
    AppHeaderMobile,
    AppHeaderExtraLarge
  }
};
</script> 